const LogoFictif = ({ name }) => {
    const colors = [
      "#ff6f61", "#6b5b95", "#88b04b", "#f7cac9", "#92a8d1", "#9fef88",
      "#f7786b", "#034f84", "#98ddde", "#deeaee", "#b565a7", "#009b77",
      "#dd4124", "#d65076", "#45b8ac", "#e15d44", "#7fcdcd", "#b0c4de",
      "#c94c4c", "#f6abb6", "#c2b280", "#b39eb5", "#ffb347", "#77dd77",
      "#aec6cf", "#836953", "#779ecb", "#fdfd96", "#b19cd9", "#ff6961",
      "#cab577", "#ff7b25", "#cfcfc4", "#fdcae1", "#a2c2e0", "#c9c0bb",
      "#e0bbe4", "#d5aa7b", "#f4a460", "#bc8f8f", "#c0e0de", "#dbe9f4",
      "#fcf3cf", "#fad6a5", "#e1f7d5", "#f0e68c", "#deb887", "#add8e6",
      "#ffb6c1", "#20b2aa", "#dda0dd", "#e9967a", "#708090", "#4682b4"
    ];
  
    // Fonction de hash simple pour transformer un string en un nombre
    const hashString = (str) => {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      return Math.abs(hash);
    };
  
    const color = colors[hashString(name) % colors.length];
  
    
  
    return (
      <svg width="150" height="150" viewBox="0 0 150 150">
        <circle cx="75" cy="75" r="75" fill={color} />
        <text
          x="50%"
          y="50%"
          dominantBaseline="middle"
          textAnchor="middle"
          fontSize="15"
          fill="white"
          fontFamily="Arial, sans-serif"
          fontWeight="bold"
        >
          {name}
        </text>
      </svg>
    );
  };
  
  export default LogoFictif;
  